/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'rxApproval' } )
export class RxApprovalPipe implements PipeTransform {

    transform( pForwarded: boolean ): string {
        if ( pForwarded != null ) {
            return 'Forwarded';
        }
        return 'Pending';

    }
}
